module.exports = __webpack_public_path__ + "img/footer_logo.1227c2cf.png";